import React, { useState, useEffect } from 'react'
import styled from '@emotion/styled'
import Headline from 'components/Headline'
import TopNav from 'components/TopNav'
import BeginForm from 'components/BeginForm'
import RevisedBeginForm from 'components/RevisedBeginForm'
import RegisterFree from 'components/RegisterFree'
import parseStringData from './common/parseStringData'
import DeviceId from 'utils/detectDevice'
import { setBackground } from './common/createStyle'
import { domainName } from 'utils/parseDomain'
import { getCookie } from 'utils/cookie'

const showRevisedBeginForm = strDomain =>
  [
    'marathishaadi.com',
    'bengalishaadi.com',
    'punjabishaadi.com',
    'gujaratishaadi.com',
    'telugushaadi.com',
    'kannadashaadi.com',
    'tamilshaadi.com',
    'muslimshaadi.in',
  ].includes(strDomain)

const BannerContainer = styled.div`
  width: 100%;
  background-size: cover !important;
  ${setBackground}
`
const RevisedBannerContainer = styled.div`
  height: 100vh;
  width: 100%;
  background-size: cover !important;
  ${setBackground}
`
const HomeBanner = props => {
  const {
    data: {
      airtable: {
        fields: {
          webCreatives,
          mobileCreatives,
          domainLogo,
          logoDimension,
          showSixMillion,
          domainReligion,
          domainLanguage,
          topNavRightColor,
        },
      },
    },
  } = props
  const dimensionData = parseStringData(logoDimension)
  const arrHeadLineCopy = {
    C: `Meet someone<br />for life, today.`,
    H: `Meet someone<br />for life, today.`,
  }
  const [state, setState] = useState({
    bannerUrl: '',
    logoDimensions: '',
    revampViewBucket: '',
    headlineCopy: '',
  })
  useEffect(() => {
    const revampViewBucket = getCookie('revampView')
    const logoDimensions = DeviceId.isDesktop()
      ? dimensionData.desktop
      : dimensionData.mobile
    const strMobileCreatives = ['C', 'H'].includes(revampViewBucket)
      ? '["https://img2.shaadi.com/assests/2020/images/homepage-creative-m-v2.jpg"]'
      : mobileCreatives
    // const arrWebCreatives = {
    //   default: webCreatives,
    //   tvcLib:
    //     '["https://img2.shaadi.com/assests/2020/images/pressure-hatao-banner-v1.jpg", "https://img2.shaadi.com/assests/2021/images/pressure-hatao-banner-v1.jpg"]',
    // }
    // const arrMobileCreatives = {
    //   default: strMobileCreatives,
    //   tvcLib:
    //     '["https://img2.shaadi.com/assests/2020/images/pressure-hatao-m-banner-v2.jpg", "https://img2.shaadi.com/assests/2021/images/pressure-hatao-m-banner-v1.jpg"]',
    // }
    // const creativeKey = getCookie('tvcView') || 'default'
    // const arrCreatives = DeviceId.isDesktop()
    //   ? parseStringData(arrWebCreatives[creativeKey])
    //   : parseStringData(arrMobileCreatives[creativeKey])
    const arrCreatives = DeviceId.isDesktop()
      ? parseStringData(webCreatives)
      : parseStringData(strMobileCreatives)
    let bannerUrl = arrCreatives[0]
    if (arrCreatives.length > 1) {
      bannerUrl = arrCreatives[Math.floor(Math.random() * arrCreatives.length)]
    }
    const headlineCopy = ['C', 'H'].includes(revampViewBucket)
      ? arrHeadLineCopy[revampViewBucket]
      : props.data.airtable.data.leading_copy_line1
    setState({ bannerUrl, logoDimensions, revampViewBucket, headlineCopy })
  }, [])

  const renderTopNav = () => {
    return (
      <TopNav
        domainLogo={domainLogo}
        logoDimension={state.logoDimensions}
        showSixMillion={showSixMillion}
        topNavRightColor={topNavRightColor}
      />
    )
  }

  const renderContent = () => {
    return (
      <>
        {renderTopNav()}
        <div className="container">
          <div className="row">
            <Headline content={state.headlineCopy} />
            {!showRevisedBeginForm(domainName) &&
              ['A', 'D'].includes(state.revampViewBucket) && (
                <BeginForm
                  domainReligion={domainReligion}
                  domainLanguage={domainLanguage}
                />
              )}
            {showRevisedBeginForm(domainName) &&
              ['A', 'D'].includes(state.revampViewBucket) && (
                <RevisedBeginForm />
              )}
            {['E'].includes(state.revampViewBucket) && (
              <RegisterFree revampBucket="E" />
            )}
          </div>
        </div>
      </>
    )
  }

  const renderBcontent = () => {
    return (
      <>
        {renderTopNav()}
        <div
          className="container"
          style={{ position: 'absolute', bottom: '0' }}
        >
          <div className="row">
            <Headline content={state.headlineCopy} />
            {['B'].includes(state.revampViewBucket) && (
              <BeginForm
                domainReligion={domainReligion}
                domainLanguage={domainLanguage}
              />
            )}
            {['I'].includes(state.revampViewBucket) && (
              <RegisterFree revampBucket="E" />
            )}
          </div>
        </div>
      </>
    )
  }

  const renderCcontent = () => {
    return (
      <>
        {renderTopNav()}
        <div
          className="container"
          style={{ position: 'absolute', bottom: '20px' }}
        >
          <div className="row">
            <div
              style={{
                minHeight: '215px',
                width: '100%',
                background: 'rgba(0, 0, 0, 0.7)',
                borderRadius: '3px',
              }}
            >
              <Headline content={state.headlineCopy} />
              <RegisterFree revampBucket="C" />
            </div>
          </div>
        </div>
      </>
    )
  }

  return ['B', 'C', 'H', 'I'].includes(state.revampViewBucket) ? (
    <RevisedBannerContainer backgroundUrl={state.bannerUrl}>
      {['B', 'I'].includes(state.revampViewBucket)
        ? renderBcontent()
        : renderCcontent()}
    </RevisedBannerContainer>
  ) : (
    <BannerContainer backgroundUrl={state.bannerUrl}>
      {renderContent()}
    </BannerContainer>
  )
}

export default HomeBanner
